import React, { FC } from 'react'
import { use100vh } from 'react-div-100vh'
import { Button, DasaProvider } from '@dasa-health/components-react'
import { Images } from '@nsw-paginas-deslogadas/assets'
import { Paths } from '@nsw-paginas-deslogadas/constants'
import * as S from './styles'

const NotFound: FC = () => {
    const innerHeight = use100vh() || window.innerHeight

    const pageNotFound = {
        title: 'A página não existe',
        subTitle: 'Ops! Você acessou uma página que não existe. Volte para Home.',
        butonText: 'Ir para a Home',
    }

    React.useEffect(() => {
        window.history.pushState('', '', Paths.notFound)
    }, [])

    return (
        <DasaProvider>
            <S.ResetStyle>
                <S.Container innerHeight={innerHeight}>
                    <S.Content>
                        <section>
                            <S.Illustration alt={Images.Exclamation.alt} src={Images.Exclamation.src} />
                            <h1>{pageNotFound.title}</h1>
                            <div>
                                <p>{pageNotFound.subTitle}</p>
                            </div>
                        </section>
                        <S.Footer>
                            <a href={Paths.home} target="_self">
                                <Button data-testid="next-button" fullWidth={true} size="default" type="button" variant="primary">
                                    {pageNotFound.butonText}
                                </Button>
                            </a>
                        </S.Footer>
                    </S.Content>
                </S.Container>
            </S.ResetStyle>
        </DasaProvider>
    )
}

export default NotFound
